import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.applyMessageStyling()
  }

  applyMessageStyling() {
    const messageUserId = this.data.get("userId") // Get the sender's user ID from the data attribute
    const currentUserId = document.body.dataset.currentUserId // Get the viewer's user ID from the body data attribute

    // const messageBubble = this.element.querySelector(".message-bubble")
    // const messageUserEmail = this.element.querySelector(".message-user-email")
    // const messageTimestamp = this.element.querySelector(".message-timestamp")

    if (messageUserId === currentUserId) {
      this.element.classList.add("own")
    } else {
      this.element.classList.add("other")
    }
    // if (messageUserId === currentUserId) {
    //   // This message belongs to the current viewer
    //   this.element.classList.add("justify-end")
    //   messageBubble.classList.add("message-right")
    //   // Adjust text colors for current user's message
    //   messageUserEmail.classList.remove("text-gray-700")
    //   messageUserEmail.classList.add("text-white")
    //   messageTimestamp.classList.remove("text-gray-500")
    //   messageTimestamp.classList.add("text-blue-200")
    // } else {
    //   // This message belongs to another user
    //   this.element.classList.add("justify-start")
    //   messageBubble.classList.add("message-left")
    //   // Ensure default text colors for other users' messages
    //   messageUserEmail.classList.add("text-gray-700")
    //   messageTimestamp.classList.add("text-gray-500")
    // }
  }
}
